import { CheckoutConfirmedItems } from './checkoutConfirmedItems';

export interface CheckoutConfirmed {
    anio: string;

    informe: string;
    mensaje: string;
    mensaje2: string;
    pagoId: string;
    pasarelaUrl: string;
    pasarelaPopup: boolean;
    pasarelaEntidad: string;
    pasarelaReferencia: string;
    pedidos: string;
    resultado: number;
    serie: string;
    error?: string;

    // Totals
    importeArticulos: number;
    importeBruto: number;
    importeBrutoIncluidoDescuento: number;
    importeDescuento: number;
    importeIva: number;
    importeNfu: number;
    importePortes: number;
    importePromos: number;
    importeTotal: number;
    puntos: number;
    textoImpuesto: string;

    annotations: string;

    // Send
    sendNombre: string;
    sendDireccion: string;
    sendCp: string;
    sendMunicipio: string;
    sendProvincia: string;
    sendPais: string;

    // Bill
    billNombre: string;
    billNif: string;
    billDireccion: string;
    billCp: string;
    billMunicipio: string;
    billProvincia: string;
    billPais: string;

    payment: string;

    items: CheckoutConfirmedItems[];

}

export class CheckoutConfirmedHelper {

    static create(): CheckoutConfirmed {
        return {
            anio: '',

            informe: '',
            mensaje: '',
            mensaje2: '',
            pagoId: '',
            pasarelaUrl: '',
            pasarelaPopup: false,
            pasarelaEntidad: '',
            pasarelaReferencia: '',
            pedidos: '',
            resultado: -1,
            serie: '',
            error: undefined,

            // Totals
            importeArticulos: 0,
            importeBruto: 0,
            importeBrutoIncluidoDescuento: 0,
            importeDescuento: 0,
            importeIva: 0,
            importeNfu: 0,
            importePortes: 0,
            importePromos: 0,
            importeTotal: 0,
            puntos: 0,
            textoImpuesto: '',

            annotations: '',

            // Send
            sendNombre: '',
            sendDireccion: '',
            sendCp: '',
            sendMunicipio: '',
            sendProvincia: '',
            sendPais: '',

            // Bill
            billNombre: '',
            billNif: '',
            billDireccion: '',
            billCp: '',
            billMunicipio: '',
            billProvincia: '',
            billPais: '',

            payment: '',
            items: []
        };
    }


    /**
     * Compoun id of checkout
     *
     * @readonly
     * @type {string}
     */
    static getId(checkoutConfirmed: CheckoutConfirmed): string {
        return checkoutConfirmed.anio + '/' + checkoutConfirmed.serie + '/123123123123';
    }

    static transformFromApi(apiData: Object): CheckoutConfirmed {
        const confirmed = CheckoutConfirmedHelper.create();
        confirmed.anio = apiData['ANIO'];
        confirmed.importePortes = apiData['IMPORTE_PORTES'];
        confirmed.importeTotal = apiData['IMPORTE_TOTAL'];
        confirmed.informe = apiData['INFORME'];
        confirmed.mensaje = apiData['MENSAJE'];
        confirmed.mensaje2 = apiData['MENSAJE2'];
        confirmed.pagoId = apiData['PAGO_ID'];
        confirmed.pasarelaUrl = apiData['PASARELA_URL'];
        confirmed.pasarelaPopup = apiData['PASARELA_POPUP'];
        confirmed.pasarelaEntidad = apiData['PASARELA_ENTIDAD'];
        confirmed.pasarelaReferencia = apiData['PASARELA_REFERENCIA'];

        confirmed.pedidos = apiData['PEDIDOS'];
        confirmed.resultado = parseInt(apiData['RESULTADO'], 10);
        confirmed.serie = apiData['SERIE'];
        confirmed.error = apiData['CODIGO_ERROR'];
        return confirmed;
    }

    /**
     * Check if checkoutConfirmed is valid
     *
     * @return boolean True if is valid otherwise false
     *
     */
    static isValid(checkoutConfirmed: CheckoutConfirmed): boolean {
        if (checkoutConfirmed) {
            return (checkoutConfirmed.resultado === 0)
            && /[0-9]+/.test(checkoutConfirmed.mensaje2);
        }
    }
}
